import { render, staticRenderFns } from "./referral-info.vue?vue&type=template&id=1469a531&scoped=true&"
import script from "./referral-info.vue?vue&type=script&lang=js&"
export * from "./referral-info.vue?vue&type=script&lang=js&"
import style0 from "./referral-info.vue?vue&type=style&index=0&id=1469a531&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1469a531",
  null
  
)

export default component.exports